export enum EventStatusEnum {
  NEW = "NEW",
  CONTACTED = "CONTACTED",
  BIDSENT = "BIDSENT",
  AWAITINGPAYMENT = "AWAITINGPAYMENT",
  EXPIRED = "EXPIRED",
  FOLLOWEDUP = "FOLLOWEDUP",
  COMPLETE = "COMPLETE",
  CANCELLED = "CANCELLED",
  DATE_FULL = "DATE_FULL",
}

// Static lists for different filtering contexts
export const NON_COMPLETE_STATUSES: EventStatusEnum[] = [
  EventStatusEnum.NEW,
  EventStatusEnum.CONTACTED,
  EventStatusEnum.BIDSENT,
  EventStatusEnum.AWAITINGPAYMENT,
  EventStatusEnum.EXPIRED,
  EventStatusEnum.FOLLOWEDUP,
  EventStatusEnum.CANCELLED,
  EventStatusEnum.DATE_FULL,
];

export const COMPLETE_STATUSES: EventStatusEnum[] = [EventStatusEnum.COMPLETE];

export const ALL_STATUSES: EventStatusEnum[] = [
  ...NON_COMPLETE_STATUSES,
  ...COMPLETE_STATUSES,
];

// Status display labels
export const statusLabels: Record<EventStatusEnum, string> = {
  [EventStatusEnum.NEW]: "New",
  [EventStatusEnum.CONTACTED]: "Contacted",
  [EventStatusEnum.BIDSENT]: "Bid Sent",
  [EventStatusEnum.AWAITINGPAYMENT]: "Awaiting Payment",
  [EventStatusEnum.EXPIRED]: "Expired",
  [EventStatusEnum.FOLLOWEDUP]: "Followed Up",
  [EventStatusEnum.COMPLETE]: "Complete",
  [EventStatusEnum.CANCELLED]: "Cancelled",
  [EventStatusEnum.DATE_FULL]: "Date Full",
};

// Status colors for UI badges and display.
//
// The old set was a light-mode palette — a 50 wash behind 700 text — which on
// the dark theme reads as a row of bright slabs. These are the dark equivalent:
// a 10% wash, text at 300, and a hairline at 30%.
//
// Four of these statuses mean something in their own right, so they take the
// semantic tokens and keep that meaning if the palette is ever retuned. The
// other five are consecutive stages of one pipeline, where the only job of the
// colour is to tell them apart, so they stay distinct hues.
export const statusColors: Record<EventStatusEnum, string> = {
  [EventStatusEnum.NEW]: "bg-sky-500/10 text-sky-300 border-sky-500/30",
  [EventStatusEnum.CONTACTED]:
    "bg-violet-500/10 text-violet-300 border-violet-500/30",
  [EventStatusEnum.BIDSENT]:
    "bg-indigo-500/10 text-indigo-300 border-indigo-500/30",
  [EventStatusEnum.AWAITINGPAYMENT]:
    "bg-warning/10 text-warning border-warning/30",
  [EventStatusEnum.EXPIRED]: "bg-muted text-muted-foreground border-border",
  [EventStatusEnum.FOLLOWEDUP]:
    "bg-teal-500/10 text-teal-300 border-teal-500/30",
  [EventStatusEnum.COMPLETE]: "bg-success/10 text-success border-success/30",
  [EventStatusEnum.CANCELLED]:
    "bg-destructive/10 text-destructive border-destructive/30",
  [EventStatusEnum.DATE_FULL]:
    "bg-rose-500/10 text-rose-300 border-rose-500/30",
};

// Background colors for status dots in dropdowns. A dot is a few pixels with
// no text on it, so it takes the solid 400 rather than the wash — at 10% alpha
// it would be invisible.
export const statusBgColors: Record<EventStatusEnum, string> = {
  [EventStatusEnum.NEW]: "bg-sky-400",
  [EventStatusEnum.CONTACTED]: "bg-violet-400",
  [EventStatusEnum.BIDSENT]: "bg-indigo-400",
  [EventStatusEnum.AWAITINGPAYMENT]: "bg-warning",
  [EventStatusEnum.EXPIRED]: "bg-muted-foreground",
  [EventStatusEnum.FOLLOWEDUP]: "bg-teal-400",
  [EventStatusEnum.COMPLETE]: "bg-success",
  [EventStatusEnum.CANCELLED]: "bg-destructive",
  [EventStatusEnum.DATE_FULL]: "bg-rose-400",
};
